import React, { useState } from 'react'
import { SaveOutlined } from "@ant-design/icons";
import { Tooltip } from 'antd';

 export const SaveOutlinedIcon = () => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <Tooltip title="Save As">
            <div
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <SaveOutlined
                    style={{
                        fontSize: "20px",
                        color: !isHovered ? "rgb(163, 149, 218)" : "#1890ff",
                        transition: "transform 0.3s ease, color 0.3s ease",
                        transform: isHovered ? "scale(1.4)" : "scale(1)",
                    }}
                />
            </div>
        </Tooltip>
    );
}

export default SaveOutlinedIcon